import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function SecurityThreatProtection() {
  useSeo(
    'Security & Threat Protection | Rev-Tech Services',
    'Rev-Tech security solutions combine endpoint protection, threat detection, remediation, and training to reduce cyber risk.',
    {
      canonical: 'https://www.rev-technology.com/services/security-threat-protection'
    }
  );

  return (
    <div className="page">
      <h1>Security & Threat Protection</h1>
      <section className="content-section">
        <p>
          Our security services combine advanced endpoint protection, threat detection, and remediation to keep your
          business safe from cyber attacks. We help you stay ahead of malware, phishing, ransomware, and other evolving threats.
        </p>
      </section>

      <section className="content-section">
        <h2>What&apos;s Included</h2>
        <ul className="values-list">
          <li><strong>Endpoint protection:</strong> Antivirus and device security across workstations, laptops, and servers.</li>
          <li><strong>Threat detection:</strong> Continuous monitoring for suspicious activity and intrusion attempts.</li>
          <li><strong>Remediation:</strong> Rapid response and cleanup to stop incidents before they spread.</li>
          <li><strong>Security training:</strong> Awareness programs that help your team recognize and avoid threats.</li>
        </ul>
      </section>

      <section className="content-section">
        <h2>Why it matters</h2>
        <p>
          Cybersecurity protects your data, reputation, and operations. With Rev-Tech securing your environment, you can
          focus on business growth and compliance while reducing the risk of costly breaches.
        </p>
      </section>

      <Link to="/services" className="cta-button">Back to Services</Link>
    </div>
  );
}

export default SecurityThreatProtection;
